import {useEffect,  useState}from 'react'
import { Table,Space,Flex, App,Modal } from 'antd';
import { useBnsXiangMuXuQiuDelMutation, useBnsXiangMuXuQiuListQuery } from '../../store/BnsKeJiApi';
import { useSearchParams } from 'react-router-dom';
import ModuleAdd from './ModuleAdd';
import ModuleEdit from './ModuleEdit';
import ModuleCheck from './ModuleCheck';
import ModalDel from '../../cpn/ModalDel';
import {DownCircleOutlined,} from '@ant-design/icons';
import { useNavigateWithTags } from '../../cpn/useNavigateWithTags';
import ProjectSelect from '../project/ProjectSelect';
import { SettingOutlined } from '@ant-design/icons';
function ModuleList(props) {  
    const {message} = App.useApp()
    const [param,setParam] = useSearchParams()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const bxm_id = param.get('bxm_id')
    const bxm_name = param.get('bxm_name')
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsXiangMuXuQiuListQuery({bxmxq_bxm_id:bxm_id},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bxmxq_id:key,bxmxq_name,bxmxq_ctime,bxmxq_cname,bxmxq_content,bxmxq_bxm_name,bxmxq_bxm_id} = item;
                    return item = {key,bxmxq_name,bxmxq_ctime,bxmxq_cname,bxmxq_content,bxmxq_bxm_name,bxmxq_bxm_id}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bxmxq_ctime;
                    let bTimeString = b.bxmxq_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'bxmxq_name',
            title: '模块名称',
            dataIndex: 'bxmxq_name',
            render: (text, record) => (
                <ModuleCheck
                    bxmxq_name={record.bxmxq_name}
                    bxm_name={record.bxmxq_bxm_name}
                    bxm_id={record.bxmxq_bxm_id}
                    bxmxq_content={record.bxmxq_content}
                    bxmxq_cname={record.bxmxq_cname}
                    bxmxq_ctime={record.bxmxq_ctime}
                    bxmxq_id={record.key}
                />
            )
        }, 
        {
            key: 'bxm_name',
            title: '项目',
            dataIndex: 'bxm_name',            
        },          
       
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bxmxq_ctime + record.bxmxq_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <ModuleEdit bxmxq_id={record.key} bxm_id={bxm_id} bxm_name={bxm_name} eu_id={eu_id} eu_name={eu_name}/>
                        <ModalDel onOk={() => {
                                                del({bxmxq_id:record.key}).then((res) => {
                                                    console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.success('删除成功！')                                                                              
                                                    }
                                                    if (res.data.Status === 'fail') {
                                                        message.error('删除失败！'+res.data.Message)
                                                    }
                                                })
                                            }} />  
                        <a 
                            onClick={() => {
                            navi(`/RateList?bxm_id=${record.bxmxq_bxm_id}&bxm_name=${record.bxmxq_bxm_name}&bxmxq_id=${record.key}&bxmxq_name=${record.bxmxq_name}`,'评分')}
                            }><DownCircleOutlined /> 评分</a>
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsXiangMuXuQiuDelMutation()
    const navi = useNavigateWithTags()
    const [open, setOpen] = useState(false);
    return (
        <>  
            <a onClick={() => { setOpen(true) }}><SettingOutlined /> 模块设置</a>
            <Modal
                open={open}
                width={1000}
                title={props.bxm_name + " - 模块设置"}
                onCancel={() => { setOpen(false); }}
            >  
                <Flex style={{ marginBottom: 16 }} justify='space-between'>
                    <ProjectSelect
                        onChange={(e,f)=>{
                            setParam({
                                bxm_id:e,
                                bxm_name:f,                            
                            })
                        }}
                        FormStyle={{marginBottom:"0"}}
                        style={{width:'200px'}}
                        defaultId={bxm_id}
                    />
                    <ModuleAdd eu_id={eu_id} eu_name={eu_name} bxm_id={bxm_id} bxm_name={bxm_name}/>
                </Flex>       
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    style={{marginTop:"20px"}}
                    pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}}                 
                />
            </Modal>
        </>
    )
}

export default ModuleList
